import Slider from "react-slick";
import { Box, makeStyles } from "@material-ui/core";

import { QuoteLineItem } from "../../../../api/Quote/QuoteLineItem";
import { sliderSettings } from "../../../../components/Slider";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

export const QuoteDetailSlider = ({ lineItems }: Props) => {
  const classes = useStyles();
  const { isMoreThanMd } = useBreakpoint();

  if (lineItems === null) {
    return null;
  }

  const slideRender = function (item: QuoteLineItem) {
    if (item === null || item.imageUrl === null) {
      return null;
    }

    return (
      <Box key={item.productId}>
        <img alt={item.name} src={item.imageUrl} />
      </Box>
    );
  };

  return (
    <Box border={isMoreThanMd ? "solid 1px #dfdfdf" : "none"}>
      <Slider {...sliderSettings} autoplay={true} autoplaySpeed={8000} className={classes.imageSlider}>
        {lineItems.map((li) => slideRender(li))}
      </Slider>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  imageSlider: {
    "& .slick-dots li button:before": {
      fontSize: theme.typography.caption,
      display: "none"
    },
    "& .slick-slide img": {
      margin: "auto",
      maxHeight: "321px",
      maxWidth: "300px",
      objetFit: "cover",
      outline: "transparent",
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3),
      [theme.breakpoints.down("md")]: {
        maxHeight: "320px",
        maxWidth: "220px"
      }
    },
    "& .slick-slide .MuiBox-root": {
      outline: "transparent"
    },
    "& .slick-next, & .slick-prev": {
      display: "none !important"
    }
  }
}));

interface Props {
  lineItems: QuoteLineItem[] | null;
}
